/**
 * HEADER MAIN MENU VIEW TEMPLATE
 *
 * @version 0.1
 */

import React from 'react';

function Template({language, products}) {
    return (
        products.length > 1 &&
        <div className="header__menu-item header__menu-item--productSwitcher">
            <div
                className="header__menu-link productSwitcher grid-header no-print-hidden">
            </div>
            <div className="dropdown-content dropdown-content--productSwitcher">
                {
                    products.map((item, index) => {
                        let itemUrl = item.url;
                        let displayedName = {__html: item.name};



                        if (item.name.indexOf("&#174;") > -1) {
                            let nameParts = (item.name).split("&#174;");
                            displayedName = {__html: `${nameParts[0]}<sup>&reg;</sup>${nameParts[1]}`};
                        } else if (item.name.indexOf("Diligence") > -1) {
                            displayedName = {__html: `${item.name}<sup>&trade;</sup>`};
                        }

                        if (item.name.indexOf("Dossier") > -1) {
                            itemUrl += "&lang=" + language.replace("-", "_") +
                                "&unique=" + Math.floor(Math.random() * 10000000000000);
                            return <a key={"product_" + index}
                                      href={itemUrl}
                                      rel="noopener"
                                      target="_blank"
                                      className="header__menu-link"
                            >
                                        <span className="product-span" dangerouslySetInnerHTML={displayedName}/>
                            </a>
                        }else if (item.name.indexOf("Entity Insight") > -1) {
                            return <a key={"product_" + index}
                                      rel="noopener noreferrer"
                                      target="_blank"
                                      className="header__menu-link"
                            >
                                        <span className="product-span" dangerouslySetInnerHTML={displayedName}/>
                            </a>
                        } else {
                            return <a key={"product_" + index}
                                      href={itemUrl}
                                      rel="noopener noreferrer"
                                      target="_blank"
                                      className="header__menu-link"
                            >
                                        <span className="product-span" dangerouslySetInnerHTML={displayedName}/>
                            </a>
                        }
                    })
                }
            </div>
        </div>
    );

}

export default Template;


// WEBPACK FOOTER //
// ./src/scripts/reusable/Header/templates/Header.productSwitcher.jsx